import { IonCard, IonCardContent, IonItem, IonLabel, IonSelectOption, IonText, useIonToast } from '@ionic/react';
import { barcodeOutline, calendarOutline, cardOutline, ellipsisHorizontalOutline, leafOutline, personOutline, phonePortraitOutline, sendOutline } from 'ionicons/icons';
import { useContext, useEffect, useState } from 'react';

import ActionButton from '../../components/button/ActionButton';
import InputItem from '../../components/input/InputItem';
import SlideContent from '../../components/slide-content/SlideContent';
import { DataProvider } from '../../library/DataProvider';
import { DepositPostAction } from '../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { AuthContext } from '../../context/AuthContext';
import CheckBoxItem from '../../components/checkbox/CheckBoxItem';
import RadioItem from '../../components/radio/RadioItem';
import { Empty } from '../../layouts/errors/Empty';

interface Props {
    campaign_id: string,
    pay_do: string,
    isPlanting?: boolean,
    seedlings?: any
}

const Offline: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const { auth } = useContext(AuthContext);

    const dispatch = useAppDispatch()
    const { form_loading, resp } = useAppSelector(state => state.depositPost)

    const [form, setForm] = useState({
        full_name: { value: "", validation: {}, error: "" },
        mobile: { value: "", validation: { required: true }, error: "" },
        amount: { value: "", validation: { min_amount: window.initials?.donation_min !== undefined ? window.initials?.donation_min : 50000, required: true }, error: "" },
        tracking_code: { value: "", validation: {}, error: "" },
        card_number: { value: "", validation: { required: false }, error: "" },
        date: { value: "", validation: { required: true }, error: "" },
        transfer_type: { value: "", validation: { required: true }, error: "" },
        anonymous: { value: false, validation: {}, error: "", disabled: false },
        anonymous_price: { value: false, validation: {}, error: "", disabled: false },
        anonymous_profile: { value: false, validation: {}, error: "", disabled: false },
        seedling_type: { value: "", label: "", validation: props.isPlanting ? { required: true } : { required: false }, error: "" },
    });

    const [formProvider, setFormProvider] = useState(() => new DataProvider(form, setForm));

    useEffect(() => {
        let formVars = { ...form };

        if (auth) {
            formVars.mobile.validation.required = false;
        }

        setForm(formVars);

        setFormProvider(() => new DataProvider(form, setForm));
    }, [auth]);

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        console.log(props.pay_do);
        
        if (formValidation) {
            dispatch(DepositPostAction(form.amount.value.replace(/\D+/g, ''), form.tracking_code.value, form.card_number.value, form.date.value, form.transfer_type.value, Number(props.campaign_id), form.mobile.value, form.full_name.value, form.anonymous.value, form.anonymous_price.value, form.anonymous_profile.value, props.pay_do, form.seedling_type.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 7000, color: "tertiary" })

                    formProvider.reset();
                } else {
                    toast({ message: resp.message, duration: 4000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    const checkAnonymous = (e: any) => {
        var f = { ...form }

        if (formProvider.form.anonymous.value) {
            f.anonymous_price.disabled = true;
            f.anonymous_price.value = false;

            f.anonymous_profile.disabled = true;
            f.anonymous_profile.value = true;
        } else {
            f.anonymous_price.disabled = false;
            f.anonymous_price.value = false;

            f.anonymous_profile.disabled = false;
            f.anonymous_profile.value = false;
        }

        setForm(f)
    }

    return <SlideContent type="segment">
        <IonCard>
            <Empty text='برای درج مشخصات فیش واریزی ابتدا باید وارد حساب کاربری خود شوید.' icon={cardOutline} length={auth ? 1 : 0}>
                <IonCardContent>
                    <div className="monthly-pay-offline">
                        <div className="accounts">
                            <IonItem>
                                <IonText className="header">حساب های زیر به نام نذرطبیعت وطن ما</IonText>
                            </IonItem>
                            <IonItem>
                                <IonLabel color="medium">شماره کارت</IonLabel>
                                <IonText>{props.isPlanting ? 5041721112140612 : 5041727010029716}</IonText>
                            </IonItem>
                            <IonItem>
                                <IonLabel color="medium">شماره حساب</IonLabel>
                                <IonText>بانک رسالت 6450907</IonText>
                            </IonItem>
                            <IonItem>
                                <IonLabel color="medium">شماره شبا</IonLabel>
                                <IonText>IR 720700001000226450907001</IonText>
                            </IonItem>
                            <IonItem>
                                <IonLabel color="medium">کد USSD</IonLabel>
                                <IonText className="ltr">*780*5077#</IonText>
                            </IonItem>
                        </div>

                        <form onSubmit={formSubmitHandler}>
                            {props.isPlanting ?
                                <InputItem name="seedling_type" type="select2" label="نوع نهال" icon={leafOutline} provider={formProvider}>
                                    {props.seedlings?.map((item: any) => {
                                        return <RadioItem value={item['id']} label={item['type']} />
                                    })}
                                </InputItem>
                                : null}

                            <AuthContext.Consumer>
                                {
                                    (context) => {
                                        return !context.auth ? <>
                                            <InputItem name="full_name" type="text" label="نام کامل" icon={personOutline} maxlength={50} provider={formProvider} />

                                            <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} ltr={true} provider={formProvider} />
                                        </> : null
                                    }
                                }
                            </AuthContext.Consumer>

                            <InputItem name="amount" type="number" label="مبلغ واریزی" icon={cardOutline} maxlength={15} ltr spaced provider={formProvider} />

                            <InputItem name="tracking_code" type="tel" label="کد پیگیری" icon={barcodeOutline} maxlength={30} ltr spaced provider={formProvider} />

                            <InputItem name="card_number" type="tel" label="چهار رقم آخر شماره کارت" icon={cardOutline} maxlength={4} ltr spaced provider={formProvider} />

                            <InputItem name="date" type="datepicker" dateType="current" label="تاریخ واریز" icon={calendarOutline} maxlength={10} provider={formProvider} ltr spaced />

                            <InputItem name="transfer_type" type="select2" label="نحوه انتقال" icon={sendOutline} provider={formProvider}>
                                <RadioItem value="card" label='کارت به کارت'/>
                                <RadioItem value="account" label='انتقال به حساب'/>
                                <RadioItem value="ussd" label='کد USSD'/>
                                <RadioItem value="paypal" label='PAYPAL'/>
                            </InputItem>

                            <CheckBoxItem name="anonymous" key="anonymous" label="حمایت به صورت ناشناس" provider={formProvider} click={(e: any) => checkAnonymous(e)} />

                            <CheckBoxItem name="anonymous_price" key="anonymous_price" label="عدم نمایش مبلغ" disabled={form.anonymous_price.disabled} provider={formProvider} />

                            <CheckBoxItem name="anonymous_profile" key="anonymous_profile" label="عدم نمایش تصویر پروفایل" disabled={form.anonymous_profile.disabled} provider={formProvider} />

                            <ActionButton text="ارسال مشخصات واریزی" loading={form_loading} />
                        </form>
                    </div>
                </IonCardContent>
            </Empty>
        </IonCard>
    </SlideContent>
}

export default Offline